<template>
    <div id="typetablecell_main">
        <div>
            {{ data || '-' }}
        </div>
    </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'

  export default {
    name: 'typeTableCell',
    mixins: [ clickaway ],
    props: {
      data: {
        type: String
      }
    },
    data(){
      return{

      }
    },
    methods:{

    }
  }
</script>

<style scoped>
    #typetablecell_div{
        display: flex;
        align-items: center;
        position: relative;
    }
    #typetablecell_div > i{
        display: flex;
        height: 100%;
        position: absolute;
        right: -18px;
        align-items: center;
    }
    #typetablecell_input{
        display: flex;
        min-width: 100%;
        border: 1px solid var(--color-main);
    }
    #typetablecell_input:focus{
        outline: none;
    }
</style>
